/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function DateInput({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion/DateInput",
  onChange,
  isInvalid,
  size,
  disabled,
  maxWidth,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0
  
}) {
let questionAnswerValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'answer',
format: fromFormat.dateISOIn,
})
let questionAnswerIsValidData = fromData.useDataIsValid({ viewPath,
context: 'question',
path: 'answer',
validate: fromValidate.date,
})
let questionAnswerChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer',
formatOut: fromFormat.dateShortOut,
})
let questionNameValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="date"
 placeholder="mm/dd/yyyy"
 data="question.answer"
 format="/Data/format.js dateISOIn"
 formatOut="/Data/format.js dateShortOut"
 validate="/Data/validate.js date"
 onChange={questionAnswerChangeData}
 value={questionAnswerValueData}
 isInvalid={!questionAnswerIsValidData}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 data="question.name"
 text={questionNameValueData}
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}